import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Input, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Pagination } from '@app/core/model/pagination.model';
import { SlideScrollService } from '@app/shell';
import { tap } from 'rxjs/operators';
import { AchievementsListService } from '@app/achievements/service/list/list.service';
import { ShowHide } from '@app/core/animation/show-hide.animation';

@Component({
    selector: 'app-achievements-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    animations: [ShowHide],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AchievementsListComponent implements OnInit, OnDestroy {
    private readonly achievementsListService = inject(AchievementsListService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly slideScrollService = inject(SlideScrollService);

    @Input() type: 'me' | null = null;
    private subscriptions$ = new Subscription();

    loading$ = this.achievementsListService.loading;

    ngOnInit() {
        this.subscriptions$.add(this.achievementsListService.updates.pipe(tap(() => this.changeDetectorRef.detectChanges())).subscribe());

        this.subscriptions$.add(
            this.slideScrollService.endReached$
                .pipe(
                    tap(() => {
                        if (!this.loading$.value) {
                            this.achievementsListService.nextPage();
                            this.changeDetectorRef.detectChanges();
                        }
                    }),
                )
                .subscribe(),
        );
    }

    ngOnDestroy() {
        this.achievementsListService.pagination = { offset: 0, limit: this.pagination.limit };
        this.subscriptions$.unsubscribe();
    }

    get activeType() {
        return this.achievementsListService.type.value;
    }

    get achievements() {
        return (this.achievementsListService?.getBadgesAllLoaded() ?? []).filter((_, index) => (this.type === 'me' ? index < 6 : true));
    }

    get hasBadges(): boolean {
        return this.totalBadges > 0;
    }

    get totalBadges(): number {
        return <number>this.achievementsListService.total;
    }

    get pagination() {
        return this.achievementsListService.pagination;
    }

    set pagination(pagination: Pagination) {
        this.achievementsListService.pagination = pagination;
    }

    isBadgeAvailableToUser(missionId: string) {
        return this.achievementsListService.accessableMissionsIds?.includes(missionId) ?? false;
    }
}
